const initState = () => ({
	stores: [],
})

export const state = initState

export const getters = {
	getStores: (state) => () => {
		return state.stores
	}
}

export const mutations = {
	setStores(state, {stores}) {
		state.stores = stores
	},
  resetStores(state){
    state.stores = []
  }
}

export const actions = {
  async fetchStores({commit}) {
    let stores = []
    try {
      const result = await this.$axios.$get('user/stores')

      if (result && result.value) {
        stores = result.value
        commit('setStores', { stores })
      }
      else {
        this.$toast.error('Error while fetching stores')
        console.error(result);
      }
    }
    catch (e){
      this.$toast.error('Error while fetching stores')
      console.error(e);
    }

    return stores
  },

  async getStores({commit}, filter) {
    let stores = []
    try {
      const filterString = filter
        ? `?${new URLSearchParams(filter).toString()}`
        : ''
      const result = await this.$axios.$get(`/webpos/store${filterString}`)

      if (result && !result.hasErrors) {
        stores = result.value
      }
      else {
        this.$toast.error('Error while getting stores')
      }
    }
    catch {
      this.$toast.error('Error while getting stores')
    }

    return stores
  },

  async getStoresForFilter({commit, dispatch}, filter) {
    let stores = []

    const storesResult = await dispatch('getStores', filter)
    if(storesResult?.length){
      stores = storesResult.map(store => {
        return {
          value: store.id,
          text: store.name,
        }
      })
    }

    return stores
  },
}
